module.exports = __webpack_public_path__ + "img/logo7.0bdb3398.png";